import React from "react"
import styled from "@emotion/styled"
import Section from "src/components/Section"
import Grid from "src/components/Grid"
import ScrollEntrance from "src/components/ScrollEntrance"
import SanityRichText from "src/components/SanityRichText"

import { mq, globals, typography, colors } from "src/styles"

const TableSection = styled(Section)`
  ${mq.largeAndBelow} {
    ${globals.verticalSpacing("padding-bottom")}
  }
  ${({ vertical }) =>
    `
    ${globals.verticalSpacing("padding-top", vertical)}
    ${globals.verticalSpacing("padding-bottom", vertical)}
  `}
  ${({ horizontal }) =>
    `
    ${globals.verticalSpacing("padding-left", horizontal)}
    ${globals.verticalSpacing("padding-right", horizontal)}
  `}
  ${mq.mediumAndBelow} {
    ${({ hideMobile }) => (hideMobile && "display: none")}
  }
  ${mq.largeAndUp} {
    ${({ hideDesktop }) => (hideDesktop && "display: none")}
  }
`

const TableWrapper = styled.div`
  overflow-x: scroll;
  max-width: 1225px;
  margin: 0 auto;
  padding-bottom: 20px;
`

const TableEl = styled.table`
  width: 100%;

  th,
  td {
    padding: 28px 12px;
    vertical-align: middle;
  }

  tr {
    tr:first-child,
    td:first-child {
      min-width: 235px;
    }
    tr:not(:first-child),
    td:not(:first-child) {
      min-width: 210px;
    }
  }


  tr {
    border-bottom: 1px solid #D0D7D7;

    &:first-child {
      border-bottom: 1px solid ${colors.navy};
    }
  }

  tr:nth-child(even) {
    background: rgba(239, 247, 255, 0.42);
  }

  .table__header {
    ${typography.body};
    color: ${props =>
      props.theme === "mainColor"
        ? "var(--light-text-color)"
        : "var(--main-color)"};
    th {
      text-align: center;
    }
  }

  .table__row {
    ${typography.bodySmall}
    color: ${colors.navy};
    th {
      font-weight: bold;
      text-align: left;
    }
    td {
      text-align: center;
    }
  }
`

const ScrollIndicator = styled.p`
  max-width: 1225px;
  margin: 0 auto;
  ${typography.bodySmall}
  ${mq.smallAndBelow} {
    margin-left: 1rem;
  }
  ${mq.largerAndUp} {
    display: none;
  }
`

const Table = ({
  _key,
  className,
  width = "default",
  isFirstSection,
  theme,
  spacing,
  prevTheme,
  nextTheme,
  headers,
  rows,
  hidden,
  hideMobile,
  hideDesktop,
}) => {
  if (hidden) return null

  const fullWidth = width === "fullWidth"

  return (
    <>
      <TableSection
        key={_key}
        className={className}
        setTheme={theme}
        prevTheme={prevTheme}
        nextTheme={nextTheme}
        isFirstSection={isFirstSection}
        padded={!fullWidth}
        vertical={spacing?.vertical}
        horizontal={spacing?.horizontal}
        hideMobile={hideMobile}
        hideDesktop={hideDesktop}
      >
        <Grid small="[1]" medium="m [1] m" large="[1]">
          <ScrollEntrance>
            <TableWrapper>
              <TableEl className="table" theme={theme}>
                <tbody>
                  <tr className="table__header">
                    <td></td>
                    {headers.map(h => {
                      return <th key={h._key}>{h.title}</th>
                    })}
                  </tr>
                  {rows.map((r, idx) => {
                    return (
                      <tr key={idx} className="table__row">
                        <th>{r.valueProp}</th>
                        {r.columns.map((c, idx2) => {
                          return (
                            <td key={idx2}>
                              <SanityRichText text={c._rawContent} />
                            </td>
                          )
                        })}
                      </tr>
                    )
                  })}
                </tbody>
              </TableEl>
            </TableWrapper>
            <ScrollIndicator>{"Scroll ->"}</ScrollIndicator>
          </ScrollEntrance>
        </Grid>
      </TableSection>
    </>
  )
}

Table.defaultProps = {}

export default Table
